module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-test",
    style: ({
      height: _vm.height
    })
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate),
      expression: "canAnimate"
    }],
    ref: "circleWrapper",
    staticClass: "lines-circle-wrapper"
  }, [_c('div', {
    ref: "circle",
    staticClass: "lines-circle"
  })])]), _vm._v(" "), _c('div', {
    ref: "wrapperContent",
    staticClass: "test-wrapper"
  }, [_c('div', {
    ref: "testContent",
    staticClass: "test-content"
  }, [_c('transition', {
    attrs: {
      "name": "slideLeft"
    }
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate),
      expression: "canAnimate"
    }],
    staticClass: "title"
  }, [_vm._v("\n                    ПРОЙДИ ТЕСТ на знание fifa\n                ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideRight"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate),
      expression: "canAnimate"
    }],
    staticClass: "text"
  }, [_vm._v("\n                    Ответь на 10 вопросов на время и поборись за приз — встречу\n                    с футболистом в офисе «Чемпионата». Тест обновляется\n                    каждую неделю.\n                ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideDown"
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate),
      expression: "canAnimate"
    }],
    staticClass: "btn",
    attrs: {
      "to": "/test/start"
    },
    nativeOn: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'Пройти тест')
      }
    }
  }, [_vm._v("ПРОЙТИ")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b89ca33","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Test.vue
// module id = 502
// module chunks = 1